import UILoading from '../../../../../../../components/ui/Loading';
import styled from 'styled-components';

export const LoadingA = styled(UILoading)`
  margin-top: 0 !important;
`;
